const apiUrl = "/horizontalDataTranslate"; // 测试域名，自己改成自己的
//const apiUrl = 'http://metadata-test.zhiquyun.cn/datatranslate/';//正式域名，自己改成自己的
//const apiUrl = "http://192.168.181.119:8083"; //测试域名，自己改成自己的

export default apiUrl;



// WEBPACK FOOTER //
// ./src/axios/api.js